import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { StaffAppHeader } from "@/components/StaffAppHeader";

const shellSx = {
  minHeight: "100dvh",
  display: "flex",
  flexDirection: "column",
  px: { xs: 2, md: 4 },
  py: { xs: 3, md: 4 },
  background: `
    radial-gradient(ellipse 70% 50% at 50% 0%, rgba(59, 184, 193, 0.08), transparent 55%),
    linear-gradient(180deg, #f6f7fb 0%, #f4f5f7 100%)
  `,
} as const;

/** Neutral boot state — same shell as unavailable so nothing else flashes first. */
export function ConciergeChecking() {
  return (
    <Box sx={{ ...shellSx, placeItems: "center", display: "grid" }}>
      <CircularProgress size={36} color="primary" />
    </Box>
  );
}

/** Full-page staff UI when Patient Concierge is not set up for the tenant. */
export function ConciergeUnavailable({
  title = "Patient Concierge is not available",
}: {
  title?: string;
}) {
  return (
    <Box sx={shellSx}>
      <Box sx={{ width: "100%", maxWidth: 1800, mx: "auto" }}>
        <StaffAppHeader title="Patient Concierge" active="board" />
      </Box>
      <Box
        sx={{
          flex: 1,
          display: "grid",
          placeItems: "center",
          px: 2,
        }}
      >
        <Typography
          component="h1"
          sx={{
            m: 0,
            textAlign: "center",
            fontWeight: 800,
            fontSize: { xs: "1.75rem", md: "2.125rem" },
            letterSpacing: "-0.03em",
            lineHeight: 1.15,
            color: "text.primary",
          }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
}
